<template>
  <!-- 国外 -->
  <div id="abroad-contact-duns" class="abroad-contact" v-show="!hidden">
    <div class="title" ref="title">
      <p>关联公司</p>
      <feedback position="关联公司" url="" />
    </div>
    <el-table :data="industryData" border :header-cell-style="{ background: '#f8faff', color: '#1F2D3D' }">
      <el-table-column prop="company" label="公司名" />
      <el-table-column prop="country" label="国家" />
      <el-table-column prop="province" label="省" />
      <el-table-column prop="city" label="市" />
      <el-table-column prop="address" label="地址" />
      <el-table-column prop="phone" label="电话" />
      <el-table-column prop="website" label="网站" />
    </el-table>
  </div>
</template>

<script>
import Vue from "vue";
import { mapMutations, mapState } from "vuex";
import axios from "@/firm/plugins/axios";
import { AnchorInditor } from "../../../utils";

export default Vue.extend({
  data() {
    return {
      loading: false,
      industryData: [],
      hidden: true,
    };
  },
  computed: {
    ...mapState(["company"]),
  },
  methods: {
    ...mapMutations("anchor", {
      setAnchorFlag: "setAnchorFlag",
      setCurrent: "setCurrent",
    }),
  },
  async mounted() {
    new AnchorInditor(() => {
      this.setCurrent("LXRDUNS");
    }, this.$refs["title"]);
    try {
      this.loading = true
      const res = await axios({
        method: 'GET',
        url: '/search/Credit/EnterpriseLibrary/CompanyLinkage',
        params: {
          companyName: this.company,
          countryCode: this.$route.query.countryCode
        }
      })
      this.industryData = res.data.result
      if (this.industryData.length === 0) throw new Error()
      this.hidden = false
      this.setAnchorFlag([["LXRDUNS", true]])
    } catch {
      null
    } finally {
      this.loading = false
    }
  },
});
</script>

<style lang="scss" scoped>
@import "@/firm/scss/mixin.scss";

.abroad-contact {
  background: #fff;
  padding: 1rem;
  padding-top: 0;
  @include mixin-panel-title;
}
</style>
